<div class="form-container" mat-dialog-content>
    <p>{{'projects.dialog.name' | translate}}</p>
    <mat-form-field style="width: 100%;">
        <input matInput cdkFocusInitial [(ngModel)]="data.name">
    </mat-form-field>
    <p>{{'projects.dialog.description' | translate}}</p>
    <mat-form-field style="width: 100%;">
        <textarea matInput [(ngModel)]="data.description" placeholder="{{'projects.dialog.description.hint' | translate}}"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="data" (keyup.enter)="close($event)" cdkFocusInitial>{{'model.confirm.ok' | translate}}</button>
    <button mat-button [mat-dialog-close]="null">{{'model.confirm.cancel' | translate}}</button>
</div>